<script lang="ts" setup>
import SessionItem from "@src/components/shared/session/SessionItemKanban.vue"
import NoSessions from "@src/components/states/empty-states/NoSessions.vue"
import {useChatSessionStore} from "@src/stores/chatSession"
import useStore from "@src/stores/store";

const store = useStore()

const props = defineProps<{
    sessions: any[]
}>()

const emit = defineEmits<{
    (e: 'drag-start', session: any): void
    (e: 'send-message', session: any): void
    (e: 'schedule-message', session: any): void
    (e: 'send-campaign', session: any): void
}>()

const sessionStore = useChatSessionStore()

function goToSession(session: any) {
    store.activeSidebarComponent = 'active'
    sessionStore.selectSession(session)
}

function onSendMessage(session: any) {
    emit('send-message', session)
}

function onDragStart(session: any) {
    emit('drag-start', session)
}

function onScheduleMessage(session: any) {
    emit('schedule-message', session)
}

function onSendCampaign(session: any) {
    emit('send-campaign', session)
}
</script>

<template>
    <div class="h-full overflow-y-auto scrollbar-thin">

        <template v-if="props.sessions.length > 0">
            <SessionItem
                v-for="session in props.sessions"
                :id="session.id"
                :key="session.id"
                :avatar="session.costumer?.profile_picture || 'https://sistema.dchat.com.br/images/avatar.jpg'"
                :department="session.department?.name"
                :has-new-message="session.has_new_messages"
                :last-message="session.last_message?.message"
                :last-message-date="session.last_message?.created_at"
                :name="session.costumer?.name || 'Cliente'"
                :session="session"
                :type="session.channel?.type || 'whatsapp'"
                class="cursor-move"
                draggable="true"
                @dragstart="onDragStart(session)"
                @send-message="onSendMessage"
                @send-campaign="onSendCampaign"
                @schedule-message="onScheduleMessage"
                :is-expired="session?.is_expired"
            />
        </template>

        <NoSessions v-else />
    </div>
</template>


<style scoped>

</style>